import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../DataStore/AuthContext';
import ActivityLoader from '../components/Common/ActivityLoader';
import functions from '../util/functions';

const ProtectedRoute = ({ element: Component, permissionCode = null }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const isLoggedIn = localStorage.getItem('ofc');
  const tokenInfo = functions.readUser();

  const {
    getProfiles,
    activeProfile,
    // getMyPermissions,
    myPermissions,
  } = useAuth();


  useEffect(() => {
    const checkAccess = async () => {
      if (!isLoggedIn) {
        setIsAuthorized(false);
        setLoading(false);
        return;
      }

      await getProfiles();

      if (!activeProfile) {
        setIsAuthorized(false);
        setLoading(false);
        return;
      }

      // await getMyPermissions();

      if (permissionCode) {
        if (myPermissions === 'SUPER') {
          setIsAuthorized(true);
        } else if (Array.isArray(myPermissions)) {
          if (Array.isArray(permissionCode)) {
            // Check if any permission code matches
            const hasPermission = permissionCode.some(code =>
              myPermissions.some(p => p.permission_key === code)
            );
            setIsAuthorized(hasPermission);
          } else {
            // permissionCode is a string
            const hasPermission = myPermissions.some(p => p.permission_key === permissionCode);
            setIsAuthorized(hasPermission);
          }
        } else {
          setIsAuthorized(false);
        }
      } else {
        // No permission required
        setIsAuthorized(true);
      }

      setLoading(false);
    };

    checkAccess();
  }, [isLoggedIn, activeProfile, permissionCode]);

  if (loading) return <div><ActivityLoader /></div>;
  if (!isLoggedIn) return <Navigate to="/login" />;
  if (tokenInfo && tokenInfo.secured * 1 === 0) return <Navigate to="/password-reset" />;
  if (isLoggedIn && !activeProfile) return <Navigate to="/switch" />;
  // if (!isAuthorized) return <Navigate to="/access-denied" />;

  return <Component />;
};

export default ProtectedRoute;
